import {styledByTheme} from "../../../../../themes/architecture/styled-by-theme";
import {AppHeaderCrossBrandTextDefaultBox} from "./app-header-cross-brand-text.default.box";
import {AppHeaderCrossBrandTextMrgreenBox} from "./app-header-cross-brand-text.mrgreen.box";

export const AppHeaderCrossBrandTextBox = styledByTheme(AppHeaderCrossBrandTextDefaultBox)
    .forMrGreen(AppHeaderCrossBrandTextMrgreenBox).apply();
